import { Carousel, Pagination } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

import IssueList from '@/component/IssueList';
import issues from '@/data/issues';

// import style from '@/styles/IssueList.module.scss';

function Issues() {
  return (
    <div>
      <Carousel autoplay>
        {issues.map((issue) => {
          return (
            <Link key={issue.title} to={`/issue/${issue.title.replaceAll(' ', '-')}`}>
              <div>
                <div
                  style={{
                    width: '100%',
                    height: '400px',
                    backgroundImage: `url(${issue.image})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPositionY: '25%'
                  }}
                />
              </div>
            </Link>
          );
        })}
      </Carousel>

      <IssueList issues={issues} style={{ margin: '50px 0' }} />

      <div style={{ textAlign: 'center' }}>
        <Pagination defaultCurrent={1} total={50} />
      </div>
    </div>
  );
}

export default Issues;
